import React, { FC } from 'react';
import { getProductionBatchByProductionOrderId, productionOrdersSearch } from '@reducers/search';
import { updateHeaderConfig } from '@reducers/details';
import { connect } from 'react-redux';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { NCFileSearchItem } from '@interfaces/search';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { getNCFilesByProductionOrderId } from '@reducers/manufacture';
import NcFileVersions from '@components/ncFileVersions';
import { ProductionOrderScreenProps } from '@v2/pages/productionOrder/common/interfaces';
import { loadSingleBatch } from '@reducers/batch';
import { useProductionOrderDetails } from '@v2/pages/common/hooks/useProductionOrderDetails';

interface ProductionOrderDetailsNCFileVersionsProps extends ProductionOrderScreenProps {
  ncFileData: ReducerEntityWithLoadingState<NCFileSearchItem | null>;
}

const ProductionOrderDetailsNCFileVersionsComponent: FC<ProductionOrderDetailsNCFileVersionsProps> = ({
  updateHeaderConfig,
  getNCFilesByProductionOrderId,
  getProductionBatchByProductionOrderId,
  loadSingleBatch,
  productionOrdersSearch,
  ncFileData,
}) => {
  const title = useTitle();

  useProductionOrderDetails({
    productionOrdersSearch,
    getNCFilesByProductionOrderId,
    getProductionBatchByProductionOrderId,
    loadSingleBatch,
    updateHeaderConfig,
    getAllNcFiles: true,
  });

  return (
    <DetailsPageWrapper title={title.ncFile}>
      <NcFileVersions ncFile={ncFileData.data} loaded={ncFileData.wasLoaded} />
    </DetailsPageWrapper>
  );
};

const ProductionOrderDetailsNCFileVersions = connect(({ details: { ncFileData } }) => ({ ncFileData }), {
  productionOrdersSearch,
  updateHeaderConfig,
  getNCFilesByProductionOrderId,
  getProductionBatchByProductionOrderId,
  loadSingleBatch,
})(ProductionOrderDetailsNCFileVersionsComponent);

export { ProductionOrderDetailsNCFileVersions };
